import React from 'react';
import { useTranslation } from 'react-i18next';

export default function SamsungForceDarkBanner({ onDismiss }) {
  const { t } = useTranslation();

  return (
    <div role="status" className="samsung-force-dark-mode-banner-container">
      <span>{t('samsung-force-dark-banner-component-message')}</span>
      <button
        type="button"
        onClick={onDismiss}
        className="samsung-force-dark-mode-banner-dismiss-button"
      >
        {t('samsung-force-dark-banner-component-got-it')}
      </button>
    </div>
  );
}
